import { FormLabel, Group, Item, SearchForm } from 'mailup-web-components'
import {
  resetSearchCallback,
  searchTasksCallback
} from 'Pages/TasksList/recoil/callbacks/callbacks'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback } from 'recoil'
import {
  InputSearchString,
  InputStatus,
  InputTags,
  InputType
} from './components'

const Search = () => {
  const intl = useIntl()
  const [expanded, setExpanded] = useState(false)
  const fetchResults = useRecoilCallback(searchTasksCallback, [])
  const resetSearch = useRecoilCallback(resetSearchCallback, [])

  const handleSubmit = () => {
    fetchResults()
  }

  const handleReset = () => {
    resetSearch()
  }

  const AdvancedSearchComponent = () => <AdvancedSearch />

  return (
    <SearchForm
      advanced
      labelBtnReset={intl.formatMessage({ id: 'Load.MailupCommon.Reset' })}
      labelBtnSearch={intl.formatMessage({ id: 'Load.MailupCommon.Search' })}
      expanded={expanded}
      AdvancedSearchComponent={AdvancedSearchComponent}
      onClickToggle={() => setExpanded((prev) => !prev)}
      onClickReset={handleReset}
      onSubmit={handleSubmit}
      submitClassName='test-searchButton'
      resetClassName='test-resetButton'
    >
      <Group>
        <Item>
          <InputSearchString onEnter={handleSubmit} />
        </Item>
      </Group>
    </SearchForm>
  )
}

const AdvancedSearch = () => {
  const intl = useIntl()

  return (
    <>
      <Group of={3}>
        <Item>
          <InputTags />
        </Item>
      </Group>
      <Group of={3}>
        <FormLabel>
          {intl.formatMessage({ id: 'Load.TriggersList.StatusPlaceholder' })}
        </FormLabel>
        <Item>
          <InputStatus />
        </Item>
      </Group>
      <Group of={3}>
        <FormLabel>
          {intl.formatMessage({
            id: 'Load.TriggersList.SearchRecipients.Type'
          })}
        </FormLabel>
        <Item>
          <InputType />
        </Item>
      </Group>
    </>
  )
}

export default Search
